import axios from 'axios';
import lib from '@/lib';

export default class HouseModel {
	constructor() {
		this.townFoundingShow = false;
		this.upgradeChampionShow = false;
	}
}
